import * as React from "react";

function Lock({ width, height, fill }) {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={0.4}
        d="M13.001 23.835c5.983 0 10.834-4.85 10.834-10.834 0-5.983-4.85-10.833-10.834-10.833-5.983 0-10.833 4.85-10.833 10.833 0 5.983 4.85 10.834 10.833 10.834z"
        fill="#fff"
        fillOpacity={0.56}
      />
      <path
        d="M17.063 11.623v-.791c0-1.007 0-4.062-4.063-4.062-4.062 0-4.062 3.055-4.062 4.062v.79c-1.322.293-1.766 1.15-1.766 3.002v1.083c0 2.383.737 3.12 3.12 3.12h5.417c2.383 0 3.12-.737 3.12-3.12v-1.083c0-1.853-.445-2.709-1.766-3.001zM13 16.357c-.66 0-1.191-.53-1.191-1.192 0-.66.53-1.191 1.191-1.191s1.192.53 1.192 1.191-.531 1.192-1.192 1.192zm2.438-4.853h-4.875v-.672c0-1.582.39-2.437 2.437-2.437 2.048 0 2.438.855 2.438 2.437v.672z"
        fill="#fff"
        fillOpacity={0.56}
      />
    </svg>
  );
}

export default Lock;
